import { NgModule } from '@angular/core';

import { CmpsGoalBoxComponent } from './goal-box.component';

@NgModule({
    declarations: [CmpsGoalBoxComponent],
    exports: [CmpsGoalBoxComponent],
})
export class CmpsGoalBoxModule {}
